"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockCustomImagesRequest = void 0;
var mockCustomImagesRequest = {
  customImageUUIDs: [{
    uuid: '2f2fa82a-9a3d-4c56-adaf-d5d61e1a606d'
  }, {
    uuid: '9f5377cb-cffd-4600-9442-992fbf509aa9'
  }]
};
exports.mockCustomImagesRequest = mockCustomImagesRequest;